module.exports = __webpack_public_path__ + "static/media/iron.65289b36.gif";